"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecayAbilityHandler = exports.DecayActorAbilityFactory = exports.DecayAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DecayAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Decay;
        this.__typeName = "Decay";
    }
}
exports.DecayAbilityArgs = DecayAbilityArgs;
let DecayActorAbilityFactory = class DecayActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Decay", "OneEnemies", 0);
    }
};
DecayActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Decay")
], DecayActorAbilityFactory);
exports.DecayActorAbilityFactory = DecayActorAbilityFactory;
let DecayAbilityHandler = class DecayAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            projectileType: "WhiteVaporCloud",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 60)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new core_1.VulnerabilityEffectArgs(1),
                    duration: Duration_1.Duration.Turns(4)
                });
            }
        });
    }
};
DecayAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Decay)
], DecayAbilityHandler);
exports.DecayAbilityHandler = DecayAbilityHandler;
